import React from "react";
import { Link } from "react-router-dom";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { PATH_NETZVERBUND_SCHWARZWALD, PATH_ABOUT, PATH_CONTACT } from "../utils/constants";
import { UsersIcon, MapPinIcon } from "@heroicons/react/24/outline";

const intro =
  "Gemeinsam mit anderen Praxen verbessern wir die ambulante Versorgung schwer psychisch kranker Menschen – jetzt auch hier im Schwarzwald. Als koordinierende Praxis übernehmen wir dabei eine zentrale Rolle.";

const paragraphs = [
  "Wir freuen uns sehr: Ab sofort gibt es auch im Schwarzwald einen genehmigten Netzverbund – und wir sind als Praxis ERGOTHERAPIE UND ZEIT(T)RÄUME mittendrin.",
  "Gemeinsam mit mehreren Praxen in Rottweil haben wir die Gründung auf den Weg gebracht. Bei der Umsetzung wurden wir vom IVP unterstützt.",
  "Das Besondere für uns: Die Koordination des Netzverbunds organisieren wir zentral aus unserer Praxis heraus. Eigens dafür haben wir eine erfahrene Sozialarbeiterin eingestellt, die als Bindeglied zwischen unseren Klient:innen und den beteiligten Fachdisziplinen wirkt – weitere Stellen könnten folgen.",
  "Jetzt geht es für uns darum, Erfahrungen zu sammeln und gemeinsam mit allen Beteiligten zu starten. Wir freuen uns sehr auf die Zusammenarbeit!",
];

export default function NetzverbundSchwarzwaldPage() {
  return (
    <>
      <SEOHelmet page="netzverbundSchwarzwald" pathname={PATH_NETZVERBUND_SCHWARZWALD} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalOrganization",
          "name": "Netzverbund Schwarzwald",
          "description":
            "Genehmigter Netzverbund zur Verbesserung der ambulanten Versorgung schwer psychisch kranker Menschen im Schwarzwald, zentral koordiniert über die Ergotherapiepraxis ERGOTHERAPIE UND ZEIT(T)RÄUME in Rottweil.",
          "url": "https://ergorw.de/netzverbund-schwarzwald",
          "areaServed": {
            "@type": "AdministrativeArea",
            "name": "Schwarzwald",
          },
          "memberOf": {
            "@type": "MedicalOrganization",
            "name": "Ergotherapie Rottweil - ERGOTHERAPIE UND ZEIT(T)RÄUME",
            "url": "https://ergorw.de",
          },
        })}
      </script>

      <main className="space-y-8 sm:space-y-14">
        {/* Intro */}
        <section aria-labelledby="netzverbund-title" className="relative">
          <h1
            id="netzverbund-title"
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white mb-6"
          >
            Netzverbund Schwarzwald
          </h1>
          <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed">
            {intro}
          </p>
        </section>

        {/* Main content card */}
        <section aria-labelledby="netzverbund-news" className="relative">
          <div className="flex items-start sm:items-center gap-4 sm:gap-6 mb-4">
            <div className="p-3 sm:p-4 rounded-xl bg-ergo-100/80 dark:bg-ergo-900/80 shadow-sm flex-shrink-0">
              <div className="text-ergo-600 dark:text-ergo-400">
                <UsersIcon className="h-6 w-6" />
              </div>
            </div>
            <h2
              id="netzverbund-news"
              className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900 dark:text-white"
            >
              Vernetzt versorgt nun auch im Schwarzwald
            </h2>
          </div>

          <div className="relative bg-white dark:bg-gray-800/60 rounded-xl sm:rounded-2xl shadow-sm border border-gray-200/60 dark:border-gray-700/40 p-6 sm:p-8 md:p-10">
            <div className="space-y-4 sm:space-y-5">
              {paragraphs.map((text, index) => (
                <p key={index} className="text-base text-gray-600 dark:text-gray-300 leading-relaxed">
                  {text}
                </p>
              ))}
            </div>

            {/* Coordination highlight */}
            <div className="mt-8 flex items-start gap-4 rounded-xl border border-ergo-200/60 dark:border-ergo-700/40 bg-ergo-50/60 dark:bg-ergo-900/20 p-5 sm:p-6">
              <MapPinIcon className="h-6 w-6 flex-shrink-0 text-ergo-600 dark:text-ergo-400" />
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Zentrale Koordination in Rottweil
                </p>
                <p className="mt-1 text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                  Die Koordination des Netzverbunds erfolgt über unsere Praxis ERGOTHERAPIE UND
                  ZEIT(T)RÄUME. Lernen Sie unsere{" "}
                  <Link
                    to={PATH_ABOUT}
                    className="font-medium text-ergo-700 dark:text-ergo-300 underline underline-offset-2 hover:text-ergo-800 dark:hover:text-ergo-200"
                  >
                    Koordinatorin im Team
                  </Link>{" "}
                  kennen oder{" "}
                  <Link
                    to={PATH_CONTACT}
                    className="font-medium text-ergo-700 dark:text-ergo-300 underline underline-offset-2 hover:text-ergo-800 dark:hover:text-ergo-200"
                  >
                    nehmen Sie Kontakt auf
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
